import { useEffect, useRef, useState } from 'react';

const recommendItems = [
  '아티스트, 작곡가, 프로듀서 데뷔가 목표이신 분',
  '작곡을 처음 배워 어떻게 해야 할지 막막하신 분',
  '작곡을 오래 배웠지만, 아직 아무런 성과가 없는 분',
  '미디, 탑라인, 작사, 송라이팅 등 모든 걸 한 번에 배우고 싶으신 분',
];

const lessonAreas = [
  { label: '미디 작곡', desc: 'DAW 기초부터 트랙 메이킹까지' },
  { label: '편곡', desc: '악기 레이어와 곡 구성' },
  { label: '믹싱', desc: 'EQ, Compressor, 공간계 활용' },
  { label: '마스터링', desc: '상업 음원 수준 사운드 완성' },
  { label: '랩 레슨', desc: '플로우, 라임, 발성' },
  { label: '프로듀싱 레슨', desc: '아티스트 데뷔, 음원 발매' },
  { label: '디제잉', desc: '비트매칭, 믹싱, 선곡' },
];

const qaItems = [
  {
    q: '얼마에요?',
    a: '월 30만원 — 주 1회 (월 4회), 60분\n월 35만원 — 주 1회 (월 4회), 90분',
  },
  {
    q: '뭐 준비해 가야 해요?',
    a: 'USB를 지참해 오실 경우, 본인의 프로젝트에 수업을 진행하여 체크하실 수 있습니다.',
  },
  {
    q: '악기를 다루지 못해도 작곡이 가능한가요?',
    a: '악기를 다루지 못하거나 화성학 지식이 없이도 작곡은 시작하실 수 있습니다. 꼭 필요한 각 악기의 연주법이나 필수 요소, 음향 관련 지식은 필요한 만큼 전달해 드리고 있습니다.',
  },
  {
    q: '추천 장비가 있나요?',
    a: '컴퓨터 외의 장비로는 당장 꼭 필요하지 않지만, 헤드폰 사용은 추천드리고 있습니다.',
  },
  {
    q: '앨범 발매도 도와주시나요?',
    a: '앨범 발매를 원하시는 경우, 믹싱, 아트워크, 유통 등 발매에 필요한 내용들을 알려드리고 진행해 드립니다.',
  },
];

const works = [
  { title: 'Drain K — SOUTH SIDE BOY [LP]', url: 'https://youtu.be/lpULMQ5J8F0' },
  { title: '산범 — 공주들은 원래 그래', url: 'https://youtu.be/aOETyMnWZuU' },
  { title: '허클베리피, 김지연 — 척 (Chuck)', url: 'https://youtu.be/JuyJkd75Dec' },
  { title: '올티(Olltii), LONE (론) — ollone at all one 2 [EP]', url: 'https://youtu.be/QmMscUq0DEg' },
  { title: '올티(Olltii), LONE (론) — ollone at all one 1 [EP]', url: 'https://www.youtube.com/watch?v=nl6wrKdGOyQ' },
  { title: 'Baybrick (베이브릭), LONE (론) — CEMENT [EP]', url: 'https://www.youtube.com/watch?v=HK-o50NGqrY' },
  { title: 'A.C.E — Supernatural (Hiphop Remix)', url: 'https://www.youtube.com/watch?v=wVolwKWhcCE' },
  { title: 'HOW WE (Feat. Huckleberry P)', url: 'https://www.youtube.com/watch?v=PsGmuqiXHzQ' },
  { title: 'D4SH (Feat. NSW yoon)', url: 'https://www.youtube.com/watch?v=H5dxHzA17Jg' },
  { title: 'NASTY BOUNCE 2 (Feat. CHERRY BOY 17)', url: 'https://www.youtube.com/watch?v=SqKOF2zE6h0' },
  { title: 'YEET (Feat. Boi B)', url: 'https://www.youtube.com/watch?v=kOlQYcJckEM' },
  { title: 'OH SHXT REMIX (Feat. Olltii, Chaboom, NOIDEACHILD, GFU)', url: 'https://www.youtube.com/watch?v=OG6HRoCsbLA' },
  { title: 'ED9E (Feat. CRUCiAL STAR)', url: 'https://www.youtube.com/watch?v=cJinY1sXSzg' },
  { title: 'CITY (Feat. Bizzy).. 등등', url: 'https://www.youtube.com/watch?v=8vXH07O2qKE' },
];

const djWorks = [
  { date: '2022.09.09', venue: '이태원 프릭스', event: 'Double Nine party' },
  { date: '2022.11.11', venue: '압구정 스넥', event: 'snacc Eleven' },
  { date: '2023.02.10', venue: '압구정 쿠니스', event: '210th Nasty party' },
  { date: '2023.04', venue: '압구정 웍셔너리', event: 'Afterwork with 리복' },
  { date: '2023.05.05', venue: '압구정 로우키', event: 'Double five Retro party' },
  { date: '2023.07.15', venue: '홍대 소버', event: 'No kidz zone & BTC party' },
  { date: '2023.08', venue: '롯데호텔', event: 'Seoulfulnight' },
  { date: '2023.09.15', venue: '이태원 우드서울', event: 'METRONOME After party' },
  { date: '2023.11', venue: '압구정 FIMM', event: 'Fimmil Mart' },
  { date: '2024.02.17', venue: 'CJ 아지트', event: 'Ollon at Allone Concert' },
  { date: '2024.08', venue: '대구', event: '대구 힙합 페스티벌' },
  { date: '2024.08.10', venue: '이태원 더팔러', event: 'Henny boys Vol.2' },
  { date: '2024.11.16', venue: '압구정 로우키', event: 'Aria3 release party' },
  { date: '2025.06.21', venue: '홍대 허슬러즈', event: 'Double nine district release party' },
  { date: '2025.08.16', venue: '홍대 얼라이브 홀', event: 'LUV BUG Concert' },
  { date: '2025.09.13', venue: '롯폰기 六本木CUBE 🇯🇵', event: 'Toast' },
  { date: '2025.09.27', venue: '이태원 배드에즈', event: 'Henny boys Party Vol.4' },
  { date: '2025.10.31', venue: '에비스 호텔 恵比寿 CITY CAMP 🇯🇵', event: 'THE HALLOWEEN FREQUENCY' },
  { date: '2025.12.10', venue: '홍대 허슬러즈', event: 'Hustlers Barbershop X Ninja Mag. X Henny Boys present.' },
  { date: '2026.03.10', venue: '상수 Henz club', event: 'Henny boys Vol.5' },
  { date: '2026.04.10', venue: '성수 Mixmix TV', event: 'Seoul block party' },
  { date: '2026.06.06', venue: '홍대 허슬러즈', event: 'Henny boys Retro party' },
  { date: '2026.08.15', venue: '양양 라구나 비치', event: 'Henny on the beach' },
];

export default function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  const [openQa, setOpenQa] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="bg-studio-dark py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="w-full max-w-5xl mx-auto">
        {/* Section header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-studio-gray/30 font-bebas text-[clamp(60px,10vw,140px)] leading-none block">
            03
          </span>
          <h2
            className="text-white font-bebas uppercase leading-none -mt-6 md:-mt-12"
            style={{ fontSize: 'clamp(40px, 6vw, 80px)', lineHeight: 1 }}
          >
            PRODUCER
          </h2>
          <p className="text-studio-gray font-sans text-lg md:text-xl mt-4">
            현역 프로듀서 베이브릭이 직접 지도합니다
          </p>
        </div>

        {/* Producer Intro */}
        <div
          className={`mb-20 transition-all duration-700 delay-100 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="bg-studio-card border border-studio-border rounded-lg p-8 md:p-12">
            <p className="text-white font-bebas text-3xl md:text-4xl uppercase mb-4">
              Baybrick <span className="text-studio-gold">베이브릭</span>
            </p>
            <p className="text-studio-silver font-sans text-sm md:text-base leading-relaxed mb-6">
              K-POP, Hip hop, R&B, 광고음악, BGM 등 여러 장르 씬에서 활동하고 있는 프로듀서 베이브릭(Baybrick)입니다. K-pop 그룹 A.C.E, 이마트24, 서울특별시 장애예술인 창작활성화 프로젝트 등과 경기도교육청, 김포교육청 출강, 에피, 마브, 오왼, 산범, 허클베리피, 올티, 비지, 크루셜스타, 보이비, 차붐, 체리보이17, NSW yoon, 99‘ 네스티키즈 등 여러 아티스트들과 협업을 진행하며 현업으로 활동 중입니다.
            </p>
            <p className="text-studio-silver font-sans text-sm md:text-base leading-relaxed">
              수많은 메이저들과의 작업 경험으로 랩 메이킹, 비트메이킹, 프로듀싱, 믹스, 마스터링 기초부터 앨범 발매까지 도와드립니다.
            </p>
          </div>
        </div>

        {/* Recommendations */}
        <div
          className={`mb-20 transition-all duration-700 delay-200 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              이런 분들께 추천드려요!
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {recommendItems.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 bg-studio-card border border-studio-border rounded-lg p-5 hover:border-studio-gold/50 transition-colors"
              >
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-studio-gold/10 rounded-full mt-0.5">
                  <i className="ri-check-line text-studio-gold text-sm" />
                </div>
                <p className="text-studio-light font-sans text-sm md:text-base leading-relaxed">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* What you learn */}
        <div
          className={`mb-20 transition-all duration-700 delay-300 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              어떤 걸 배우나요?
            </h3>
          </div>
          <div className="bg-studio-card border border-studio-border rounded-lg p-8 md:p-10">
            <p className="text-studio-gold font-bebas text-2xl md:text-3xl uppercase mb-4 tracking-wide">
              디제잉/ 미디작곡 / 탑라인 / 작사 / 믹싱 마스터링/프로듀싱
            </p>
            <p className="text-studio-silver font-sans text-sm md:text-base leading-relaxed mb-6">
              단순한 겉핥기 수업이 아닌 트랙 메이킹(MIDI)을 기본으로 탑라인, 작사, 믹싱 & 마스터링부터 현역 프로듀서의 노하우와 팁이 담겨 있습니다.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'DAW(Ableton) 사용법',
                '사운드 디자인, 카피',
                '퀄리티 있는 드럼 시퀀싱 방법',
                '다양한 플러그인 사용법',
                '기초 및 심화 화성학',
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 bg-studio-gold rounded-full flex-shrink-0" />
                  <span className="text-studio-light font-sans text-sm">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-studio-gray font-sans text-sm mt-6">
              작곡 실력 향상에 필요한 모든 것을 1:1로 알려드립니다 :)
            </p>
          </div>
        </div>

        {/* Lesson areas */}
        <div
          className={`mb-20 transition-all duration-700 delay-400 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              레슨 분야
            </h3>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {lessonAreas.map((area) => (
              <div
                key={area.label}
                className="bg-studio-card border border-studio-border rounded-lg p-5 text-center hover:border-studio-gold/50 transition-colors group"
              >
                <p className="text-white font-bebas text-xl uppercase mb-1 group-hover:text-studio-gold transition-colors">
                  {area.label}
                </p>
                <p className="text-studio-gray font-sans text-xs">{area.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Q&A */}
        <div
          className={`mb-20 transition-all duration-700 delay-500 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              Q &amp; A
            </h3>
          </div>
          <div className="space-y-3">
            {qaItems.map((item, i) => (
              <div
                key={i}
                className="bg-studio-card border border-studio-border rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenQa(openQa === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-studio-surface/50 transition-colors"
                >
                  <span className="text-white font-bebas text-lg md:text-xl uppercase tracking-wide">
                    {item.q}
                  </span>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 ml-4">
                    <i
                      className={`ri-arrow-down-s-line text-studio-gold text-xl transition-transform ${
                        openQa === i ? 'rotate-180' : ''
                      }`}
                    />
                  </div>
                </button>
                {openQa === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-studio-silver font-sans text-sm md:text-base leading-relaxed whitespace-pre-line">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Activity History */}
        <div
          className={`transition-all duration-700 delay-600 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              🌱&nbsp; 음반 활동이력
            </h3>
          </div>
          <div className="bg-studio-card border border-studio-border rounded-lg p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {works.map((work) => (
                <a
                  key={work.title}
                  href={work.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 group cursor-pointer"
                >
                  <div className="w-1.5 h-1.5 bg-studio-gold rounded-full flex-shrink-0 group-hover:scale-150 transition-transform" />
                  <span className="text-studio-light font-sans text-sm group-hover:text-studio-gold transition-colors">
                    {work.title}
                  </span>
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-external-link-line text-studio-gold text-xs" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* DJ Activity History */}
        <div
          className={`mt-20 transition-all duration-700 delay-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1.5 h-8 bg-studio-gold rounded-full" />
            <h3 className="text-white font-bebas text-3xl md:text-4xl uppercase tracking-wide">
              🌱&nbsp; 디제잉 활동이력
            </h3>
          </div>
          <div className="bg-studio-card border border-studio-border rounded-lg p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {djWorks.map((dj) => (
                <div
                  key={`${dj.date}-${dj.venue}`}
                  className="flex items-start gap-3 group"
                >
                  <div className="w-1.5 h-1.5 bg-studio-gold rounded-full flex-shrink-0 mt-2" />
                  <div>
                    <span className="text-studio-gold font-bebas text-sm tracking-wide mr-2">
                      {dj.date}
                    </span>
                    <span className="text-studio-light font-sans text-sm">
                      {dj.venue}
                    </span>
                    <p className="text-studio-gray font-sans text-xs mt-0.5">
                      "{dj.event}"
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}